/**
 * Module for configuring the agent assist settings as part of the KB creation wizard
 */
define(["marionette", "messaging/messenger", "./agentAssistSettingsView"], function (
  Marionette,
  Messenger,
  AgentAssistSettingsView,
) {
  const AgentAssistSettingsModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "agentAssistSettings";
      this.region = options.region;
      this.editMode = options.editMode;
    },
    show: function (kb) {
      this.kb = kb;

      this.view = new AgentAssistSettingsView.agentAssistSettingsView({ model: kb });
      this.view.on("change:version", this._onChangeVersion, this);
      this.view.on("show", this._onShow, this);

      kb.on(
        "invalid",
        function (model, error) {
          this.view.clearErrors();
          if (error["pcasLogonUrl"]) {
            this.view.pcasLogonUrlError(error["pcasLogonUrl"]);
          }
          if (error["pcasURL"]) {
            this.view.pcasUrlError(error["pcasURL"]);
          }
          if (error["company"]) {
            this.view.companyError(error["company"]);
          }
          if (error["pcasUsername"]) {
            this.view.pcasUsernameError(error["pcasUsername"]);
          }
          if (error["pcasPassword"]) {
            this.view.pcasPasswordError(error["pcasPassword"]);
          }
          if (error["pcasUserAgent"]) {
            this.view.pcasUserAgentError(error["pcasUserAgent"]);
          }
        },
        this,
      );

      this.showRegion(this.view);
    },
    getKb: function () {
      return this.kb;
    },
    updateFields: function () {
      this.kb.set("pcasLogonUrl", this.view.getPcasLogonUrl());
      this.kb.set("pcasURL", this.view.getPcasUrl());
      this.kb.set("company", this.view.getCompany());
      this.kb.set("pcasUsername", this.view.getPcasUsername());
      this.kb.set("pcasPassword", this.view.getPcasPassword());
      this.kb.set("pcasUserAgent", this.view.getPcasUserAgent());
      this.kb.set("pcasVersion", this.view.getPcasVersion());
    },
    isValid: function () {
      this.updateFields();
      return this.kb.isValid();
    },
    _onChangeVersion: function () {
      const version = this.view.getPcasVersion();
      if (version == "11") {
        this.view.showPcasLogonUrl();
      } else {
        this.view.hidePcasLogonUrl();
      }
    },
    _onShow: function () {
      this._onChangeVersion();
    },
  });

  return AgentAssistSettingsModule;
});
